export const isRawString = (value) => {
    if (!value || typeof value !== 'string')
        return false;
    return value.startsWith('RAW(') && value.endsWith(')');
};
//# sourceMappingURL=is-raw-string.js.map